import script from "./IndexPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndexPage.vue?vue&type=script&setup=true&lang=ts"

import "./IndexPage.vue?vue&type=style&index=0&id=42896455&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.7_typescript@4.9.5__webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42896455"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';import Scroll from 'quasar/src/directives/Scroll.js';
import qInstall from "../../node_modules/.pnpm/@quasar+app-webpack@3.11.3__19fadae530b491e33818dbf1a8400ef1/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QIcon,QForm,QInput,QCheckbox,QCarousel});qInstall(script, 'directives', {Scroll});
